/**
 * Affiche un texte d'histoire produit avec gestion intelligente des sauts de ligne :
 * - Une seule pression sur Entrée (\n) = saut de ligne simple (au sein d'un paragraphe)
 * - Double pression sur Entrée (\n\n ou plus) = nouveau paragraphe (vrai espacement vertical)
 *
 * Usage :
 *   <RichStory text={piece.story} className="text-white/50 text-[15px] leading-[1.9]" paragraphGap="mb-5" />
 */
export default function RichStory({ text, className = '', paragraphGap = 'mb-7', style }) {
  if (!text) return null;

  // Split sur 2 retours ou plus = paragraphes distincts
  const paragraphs = text.split(/\n\s*\n+/);

  return (
    <>
      {paragraphs.map((p, i) => (
        <p
          key={i}
          className={`${className} whitespace-pre-wrap ${i < paragraphs.length - 1 ? paragraphGap : ''}`}
          style={style}>
          {p}
        </p>
      ))}
    </>
  );
}
